export default __webpack_public_path__ + "static/media/P10003.bf08e491.png";